import { render, staticRenderFns } from "./GlobalSpanExpandible.vue?vue&type=template&id=332b1918"
import script from "./GlobalSpanExpandible.vue?vue&type=script&lang=js"
export * from "./GlobalSpanExpandible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports